import _util from '../../utils/';


const salaryLedgerService = {
	calcSingleSalary(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/CalcSingleSalary',
			params: data,
			success: resolve,
			error: reject
		})
	},
	differenceExport(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/DifferenceExport',
			params: data,
			success: resolve,
			error: reject
		})
	},
	selectSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountMonthly/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	downloadTemplate(resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/GetImportTemplate',
			success: resolve,
			error: reject
		});
	},
	downloadAdditionTemplate(resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/GetAdditionImportTemplate',
			success: resolve,
			error: reject
		});
	},
	import(posts, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/Import',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	createSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountMonthly/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	detailSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	updateSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	exportSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/Export',
			params: data,
			success: resolve,
			error: reject
		})
	},
	initiaSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/InitAccountDetails',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	caculateSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/AttendanceCalcu',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	multiSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/BatchSalaryDetails',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	checkSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/ReviewAccountDetail',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	singleSalaryLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountDetails/SalaryDetails',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	fetchNeedSettingDeliveryEmployees(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAchieveResult/GetNeedSetting',
			params: data,
			success: resolve,
			error: reject
		})
	},
	settingDeliveryEmployees(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAchieveResult/settingDeliveryEmployees',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	AttendanceSummary(data, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceRecords/AttendanceRecordsMonthlyListForSalary',
			params: data,
			success: resolve,
			error: reject
		})
	},
};


export default salaryLedgerService;


// WEBPACK FOOTER //
// ./src/services/SalaryAllowance/salary-ledger-service.js